<template>
  <div>
    <v-toolbar elevation="1" dark dense color="highlight" flat class="sticky">
      <v-toolbar-title>{{ $t("projects") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <can I="create" a="projects">
        <addProject v-on:add-project="addProject"></addProject>
      </can>
      <can I="read" a="archivedProjects">
        <v-menu
          transition="scale-transition"
          origin="right top"
          style="z-index: 10"
          class="white"
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn
              @click.prevent
              class="ml-3"
              @click.stop
              color="white"
              icon
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="300px">
            <v-list dense>
              <v-list-item @click.stop="showArchivedProjects()">
                <v-list-item-icon>
                  <v-icon color="primary">archive</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{
                  $t("archivedProjects")
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
      </can>
    </v-toolbar>
    <!-- <v-card> -->
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container' : ''">
      <dataTable
        v-on:clickItem="projectDetails"
        :items="projects"
        :progress="progress"
        :headers="headers"
      >
        <template v-slot:itemAction="{ item }">
          <v-menu
            transition="scale-transition"
            origin="right top"
            style="z-index: 10"
            class="white"
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn @click.prevent @click.stop color="primary" icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-sheet flatwidth="300px">
              <v-list dense>
                <can I="download" a="excel">
                  <v-list-item @click.stop="downloadExcel(item)">
                    <v-list-item-icon>
                      <v-icon color="success">fa-file-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{
                      $t("download")
                    }}</v-list-item-content>
                  </v-list-item>
                </can>
                <can I="download" a="logbook">
                  <downloadLogbook
                    v-on:download="(...args) => downloadLogbook(item, ...args)"
                  >
                    <template v-slot:activator="{ on }">
                      <v-list-item v-on="on">
                        <v-list-item-icon>
                          <v-icon color="primary">import_contacts</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>{{
                          $t("download")
                        }}</v-list-item-content>
                      </v-list-item>
                    </template>
                  </downloadLogbook>
                </can>
                <can I="archive" a="projects">
                  <v-list-item @click.stop="archiveProject(item)">
                    <v-list-item-icon>
                      <v-icon color="primary">fa-archive</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{
                      $t("archive")
                    }}</v-list-item-content>
                  </v-list-item>
                </can>
                <can I="delete" a="projects">
                  <areyousure
                    list_item
                    v-on:delete="deleteProject"
                    :id="item.id"
                    object="project"
                  ></areyousure>
                </can>
              </v-list>
            </v-sheet>
          </v-menu>
        </template>
        <template v-slot:cardContent="{ item }">
          <v-subheader
            class="subheading primary lighten-3 white--text font-weight-bold"
          >
            <a href="#" class="white--text" @click="projectDetails(item)">{{
              item.name
            }}</a>
            <v-spacer></v-spacer>
            <v-menu
              transition="scale-transition"
              origin="right top"
              style="z-index: 10"
              class="white"
              bottom
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  @click.prevent
                  @click.stop
                  color="primary"
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-sheet flatwidth="300px">
                <v-list dense>
                  <can I="download" a="excel">
                    <v-list-item @click="downloadExcel(item)">
                      <v-list-item-icon>
                        <v-icon color="success">fa-file-excel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{
                        $t("download")
                      }}</v-list-item-content>
                    </v-list-item>
                  </can>
                  <can I="download" a="logbook">
                    <downloadLogbook
                      v-on:download="
                        (...args) => downloadLogbook(item, ...args)
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-list-item v-on="on">
                          <v-list-item-icon>
                            <v-icon color="primary">import_contacts</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>{{
                            $t("download")
                          }}</v-list-item-content>
                        </v-list-item>
                      </template>
                    </downloadLogbook>
                  </can>
                  <can I="archive" a="projects">
                    <v-list-item @click="archiveProject(item)">
                      <v-list-item-icon>
                        <v-icon color="primary">fa-archive</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{
                        $t("archive")
                      }}</v-list-item-content>
                    </v-list-item>
                  </can>
                  <can I="delete" a="projects">
                    <areyousure
                      list_item
                      v-on:delete="deleteProject"
                      :id="item.id"
                      object="project"
                    ></areyousure>
                  </can>
                </v-list>
              </v-sheet>
            </v-menu>
          </v-subheader>

          <v-divider></v-divider>
          <div v-ripple class="pointer" @click="projectDetails(item)">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>{{ $t("building") }}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{
                  item.buildingName
                }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content
                  >{{ $t("buildingComponents") }}:</v-list-item-content
                >
                <v-list-item-content class="align-end font-weight-bold">{{
                  item.buildingComponents.length
                }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content
                  >{{ $t("createdTs") }}:</v-list-item-content
                >
                <v-list-item-content class="align-end font-weight-bold">{{
                  item.createdTs
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </template>
        <template v-slot:empty>
          <retry v-on:retry="getData()" v-if="retry"></retry>
          <emptyList
            :image="require('@/assets/buildings_logo_low_opacity.png')"
            :title="$t('noProjects')"
            v-else
          >
            <template v-slot:action>
              <can I="create" a="projects">
                <addProject v-on:add-project="addProject"></addProject>
              </can>
            </template>
          </emptyList>
        </template>
      </dataTable>
    </div>
    <!-- </v-card> -->
    <installPWA v-if="showInstall"></installPWA>
    <loadingDialog :dialog="loading"></loadingDialog>
  </div>
</template>

<script>
import retry from "@/components/Retry";
import emptyList from "@/components/EmptyList";
import addProject from "@/components/pages/Projects/AddProject";
import dataTable from "@/components/Datatable";
import downloadLogbook from "@/components/DownloadLogbook";
import installPWA from "@/components/InstallPWA";

import { validationMixin } from "vuelidate";

export default {
  name: "Projects",
  components: {
    addProject,
    retry,
    emptyList,
    dataTable,
    downloadLogbook,
    installPWA,
  },
  data() {
    return {
      progress: true,
      projects: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      retry: false,
      showInstall: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.checkBrowser();
      next();
    });
  },
  methods: {
    checkBrowser() {
      const isIos = /iphone|ipad|ipod/.test(
        window.navigator.userAgent.toLowerCase()
      );
      // Detects if device is in standalone mode
      const isInStandaloneMode = window.navigator.standalone;

      // Checks if should display install popup notification:
      if (isIos && !isInStandaloneMode) {
        this.showInstall = true;
      }
    },
    showArchivedProjects() {
      this.$router.push({ name: "ArchivedProjects" });
    },
    archiveProject(item) {
      item.status = "ARCHIVED";
      let project = item;
      delete project.buildingComponents;
      this.$http
        .updateProject(project)
        .then((res) => {
          this.projects = this.projects.filter((x) => x.id != item.id);
          this.$forceUpdate();
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch((err) => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    downloadExcel(project) {
      this.loading = true;
      this.$http
        .downloadExcelExport(project.id)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          link.setAttribute(
            "download",
            `${project.name}_${date.toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$noty.error(this.$t("error"));
          this.loading = false;
        });
    },
    downloadLogbook(project, separated, withDocuments) {
      this.loading = true;
      this.$http
        .downloadLogbook(project.id, null, separated, withDocuments)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          link.setAttribute(
            "download",
            `${project.name}_${date.toLocaleDateString()}.zip`
          );
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$noty.error(this.$t("error"));
          this.loading = false;
        });
    },
    addProject(newProject) {
      this.$http
        .addProject(newProject)
        .then((res) => {
          this.projects.push(res.data);
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch((err) => {
          this.$noty.error(err);
          console.log(err);
        });
    },
    deleteProject(id) {
      this.projects = this.projects.filter((p) => p.id != id);
    },
    projectDetails(item) {
      this.$router.push({ name: "ProjectDetails", params: { id: item.id } });
    },
    buildHeaders() {
      if (this.$can("delete", "projects")) {
        this.headers = [
          {
            text: this.$t("name"),
            align: "left",
            value: "name",
          },
          { text: this.$t("building"), value: "buildingName" },
          {
            text: this.$t("buildingComponents"),
            value: "buildingComponents.length",
          },
          // { text: this.$t("table.status"), value: "status" },
          { text: this.$t("createdTs"), value: "createdTs" },
          { text: this.$t("actions"), sortable: false, value: "actions" },
        ];
      } else {
        this.headers = [
          {
            text: this.$t("name"),
            align: "left",
            value: "name",
          },
          { text: this.$t("building"), value: "buildingName" },
          {
            text: this.$t("buildingComponents"),
            value: "buildingComponents.length",
          },
          { text: this.$t("createdTs"), value: "createdTs" },
        ];
      }
    },
    getData() {
      this.progress = true;
      this.$http
        .getProjects()
        .then((res) => {
          this.projects = res.data;
          this.progress = false;
          this.retry = false;
        })
        .catch((error) => {
          this.progress = false;
          this.retry = true;
          console.log(error.response.status);
        });
    },
  },
  created() {
    this.getData();
    this.buildHeaders();
    this.$store.state.previous = null;
    this.$store.state.breadcrumb = null;
  },
};
</script>


// WEBPACK FOOTER //
// src/views/projects/Index.vue